import React from "react";
import { Box, Paper, Typography, useTheme, Grid } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Area,
  AreaChart,
} from "recharts";

const AssessmentVisualizations = ({ stats, forStartPage = false }) => {
  const theme = useTheme();

  if (!stats) return null;

  const gradeColors = {
    A: "#2E7D32",
    B: "#1976D2",
    C: "#FFA000",
    D: "#ED6C02",
    E: "#D32F2F",
    F: "#757575",
  };

  // Förbereder data för betygsfördelning
  const gradeDistributionData = Object.entries(stats.gradeDistribution).map(
    ([grade, count]) => ({
      betyg: grade,
      antal: count,
      procent: ((count / stats.total) * 100).toFixed(1),
    }),
  );

  // Förbereder data för kriterieanalys
  const criteriaData = stats.criteriaStats.map((criteria) => ({
    kriterie: criteria.name,
    poäng: criteria.averageScore,
    maxPoäng: 5,
  }));

  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={12}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 3,
              bgcolor: theme.palette.background.paperHover,
              height: "100%",
            }}
          >
            <Typography variant="h6" sx={{ mb: 3 }}>
              Kriterieanalys
            </Typography>
            <ResponsiveContainer width="100%" height={500}>
              <RadarChart data={criteriaData}>
                <PolarGrid />
                <PolarAngleAxis dataKey="kriterie" />
                <PolarRadiusAxis angle={30} domain={[0, 5]} />
                <Radar
                  name="Poäng"
                  dataKey="poäng"
                  stroke={theme.palette.primary.main}
                  fill={theme.palette.primary.main}
                  fillOpacity={0.6}
                />
                <Tooltip formatter={(value) => `${value} poäng`} />
              </RadarChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>
        <Grid item xs={12} md={12}>
          <Paper
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 3,
              bgcolor: theme.palette.background.paperHover,
              height: "100%",
            }}
          >
            <Typography variant="h6" sx={{ mb: 3 }}>
              Betygsfördelning
            </Typography>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={gradeDistributionData}
                  dataKey="antal"
                  nameKey="betyg"
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  label={({ betyg, procent }) => `${betyg} (${procent}%)`}
                >
                  {gradeDistributionData.map((entry, index) => (
                    <Cell key={index} fill={gradeColors[entry.betyg]} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(value, name, props) => [
                    `${value} st`,
                    `Betyg ${props.payload.betyg}`,
                  ]}
                />
              </PieChart>
            </ResponsiveContainer>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AssessmentVisualizations;
